import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import ContactForm from "../components/ContactForm";

const Home = () => {
  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>React Form</title>
      </Helmet>
      <ContactForm />
    </div>
  );
};

export default Home;
